function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "SentSVGID_1_",
  points: "639.8,156 820.4,1 655.5,114.3 "
}));

var SvgSent = function SvgSent(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\xD1\\xEB\\xEE\\xE9_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 821.2 282.4",
    style: {
      enableBackground: "new 0 0 821.2 282.4"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _ref2, /*#__PURE__*/React.createElement("clipPath", {
    id: "SentSVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SentSVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 639.8,
    y: 1,
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#751480"
    },
    width: 180.6,
    height: 155
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#751480"
    },
    d: "M638.8,135.9V57.6h-6.1c12.3-24.1,30.2-45.8,52.3-64V0h136.4v157H638.8 V135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#751480"
    },
    d: "M638.8,135.9V58.2h-4.4c12.3-23.9,30-45.4,51.9-63.5V0h135.1v157H638.8 V135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#761580"
    },
    d: "M638.8,135.9V58.8h-2.7c12.2-23.7,29.8-45.1,51.5-63V0h133.7v157H638.8 V135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#761580"
    },
    d: "M638.8,135.9V59.4h-0.9c12.1-23.5,29.5-44.7,51.1-62.5V0h132.4v157 H638.8V135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#771680"
    },
    d: "M638.8,135.9V96.6V68.8h-3.5c1.3-3,2.7-5.9,4.2-8.9 c12-23.3,29.3-44.4,50.7-62V0h131.1v157H638.8V135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#771680"
    },
    d: "M638.8,135.9v-39V78.3h-5.4c2.3-6.1,4.9-12,7.9-17.8 c11.9-23.2,29.1-44,50.3-61.5v1h129.8v157H638.8V135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#781780"
    },
    d: "M638.8,135.9V97.2V78.8h-3.6c2.3-6,4.9-11.9,7.8-17.6 c11.8-23,28.8-43.7,49.9-61.1c2.6-2.2,5.3-4.3,8.1-6.4V0h120.4v157H638.8V135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#781780"
    },
    d: "M638.8,135.9V97.5V79.3h-1.8c2.2-6,4.8-11.8,7.8-17.5 c11.7-22.8,28.6-43.3,49.5-60.6c2.6-2.2,5.3-4.3,8-6.3V0h119.1v157H638.8V135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#791881"
    },
    d: "M638.8,135.9V97.8h-5.7c3.1-12.3,7.6-24.2,13.3-35.5 c11.6-22.6,28.4-43,49.1-60.1c2.6-2.1,5.2-4.2,8-6.3v4h117.9v157H638.8V135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#7A1881"
    },
    d: "M638.8,135.9V98.1h-3.9c3-12.2,7.5-24,13.2-35.2 c11.5-22.4,28.1-42.6,48.7-59.6c2.6-2.1,5.2-4.2,7.9-6.2V0h116.6v157H638.8V135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#7A1981"
    },
    d: "M632.2,135.9c0-51.3,25.2-97.8,66-131.5c2.5-2.1,5.2-4.2,7.8-6.2V0 h115.4v157H638.8v-21.1H632.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#7B1981"
    },
    d: "M634,135.9c0-50.9,25-97,65.5-130.4c5.1-4.2,10.4-8.1,15.9-11.9V0h106 v157H638.8v-21.1H634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#7C1A81"
    },
    d: "M635.9,135.9c0-50.5,24.8-96.2,64.9-129.3c5-4.1,10.3-8.1,15.7-11.8V0 h104.8v157H638.8v-21.1H635.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#7C1B81"
    },
    d: "M637.7,135.9c0-50.1,24.6-95.4,64.4-128.2c5-4.1,10.2-8,15.6-11.7v4 h103.7v157H640.3v6.6c-0.6-3-1-6-1.4-9.1C638.1,148.4,637.7,142.2,637.7,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#7D1B81"
    },
    d: "M639.6,135.9c0-49.7,24.4-94.6,63.8-127.1c4.9-4.1,10.1-7.9,15.5-11.6V0 h102.5v157H642.1v6.3c-0.6-3-1-6-1.4-9C640,148.3,639.6,142.1,639.6,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#7E1C81"
    },
    d: "M641.5,135.9c0-49.2,24.2-93.8,63.3-126.1c4.9-4,10-7.9,15.3-11.5V0 h101.3v157H644v6.1c-0.5-3-1-5.9-1.4-8.9C641.8,148.2,641.5,142.1,641.5,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#7F1D81"
    },
    d: "M643.3,135.9c0-48.8,24-93,62.7-125c4.8-4,9.9-7.8,15.2-11.4V0h100.1 v157H645.8v5.8c-0.5-2.9-1-5.9-1.4-8.8C643.7,148,643.3,142,643.3,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#7F1D82"
    },
    d: "M645.2,135.9c0-48.4,23.8-92.2,62.2-123.9c4.8-4,9.8-7.7,15.1-11.3 c2.6-1.8,5.3-3.5,8-5.2V0h90.9v157H647.6v5.6c-0.5-2.9-1-5.8-1.4-8.8C645.6,147.9,645.2,142,645.2,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#801E82"
    },
    d: "M647.1,135.9c0-48,23.6-91.4,61.6-122.8c4.8-3.9,9.7-7.7,14.9-11.2 c2.6-1.8,5.3-3.5,8-5.2V0h89.8v157H649.5v5.4c-0.5-2.9-1-5.8-1.3-8.7C647.4,147.8,647.1,141.9,647.1,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#811F82"
    },
    d: "M648.9,135.9c0-47.5,23.4-90.6,61.1-121.7c9.4-7.8,19.8-14.8,30.9-21V0 h80.5v157H651.3v5.1c-0.5-2.8-1-5.7-1.3-8.6C649.3,147.7,648.9,141.9,648.9,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#822082"
    },
    d: "M650.8,135.9c0-47.1,23.1-89.8,60.6-120.6c9.4-7.7,19.6-14.7,30.6-20.8 V0h79.4v157H653.2v4.9c-0.5-2.8-1-5.7-1.3-8.5C651.1,147.6,650.8,141.8,650.8,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#832082"
    },
    d: "M652.6,135.9c0-46.7,22.9-88.9,60-119.5c9.3-7.6,19.4-14.6,30.3-20.6V0 h78.4v157H655v4.7c-0.5-2.8-1-5.6-1.3-8.5C653,147.5,652.6,141.8,652.6,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#832182"
    },
    d: "M654.5,135.9c0-46.3,22.7-88.1,59.5-118.4C723.2,9.9,733.2,3,744-3v3 h77.4v157H656.8v4.4c-0.5-2.8-0.9-5.6-1.3-8.4C654.9,147.4,654.5,141.7,654.5,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#842282"
    },
    d: "M656.4,135.9c0-45.8,22.5-87.3,58.9-117.4c9.1-7.5,19.1-14.3,29.8-20.3 V0h76.3v157H658.7v4.2c-0.5-2.7-0.9-5.5-1.3-8.3C656.7,147.3,656.4,141.6,656.4,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#852282"
    },
    d: "M658.2,135.9c0-45.4,22.3-86.5,58.4-116.3c9-7.4,18.9-14.2,29.5-20.1V0 h75.3v157H660.5v4c-0.5-2.7-0.9-5.5-1.3-8.2C658.6,147.2,658.2,141.6,658.2,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#862382"
    },
    d: "M660.1,135.9c0-45,22.1-85.7,57.8-115.2c8.9-7.4,18.7-14,29.2-19.9 c2.6-1.5,5.3-2.9,8-4.2V0h66.2v157h-159v3.7c-0.5-2.7-0.9-5.4-1.3-8.2C660.4,147.1,660.1,141.5,660.1,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#872483"
    },
    d: "M662,135.9c0-44.6,21.9-84.9,57.3-114.1c8.8-7.3,18.5-13.9,28.9-19.7 c5.2-2.9,10.6-5.6,16.1-8.1v6h57.1v157H664.2v3.5c-0.5-2.7-0.9-5.4-1.2-8.1C662.3,147,662,141.5,662,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#872583"
    },
    d: "M663.8,135.9c0-44.1,21.7-84.1,56.7-113c8.8-7.2,18.4-13.8,28.7-19.5 c5.2-2.9,10.5-5.5,16-8V0h56.2v157H666.1v3.3c-0.5-2.6-0.9-5.3-1.2-8C664.2,146.9,663.8,141.4,663.8,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#882683"
    },
    d: "M665.7,135.9c0-43.7,21.5-83.3,56.2-111.9c8.7-7.2,18.2-13.6,28.4-19.3 c5.1-2.8,10.4-5.5,15.8-7.9V0h55.3v157H667.9v3c-0.5-2.6-0.9-5.3-1.2-7.9C666,146.8,665.7,141.4,665.7,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#892683"
    },
    d: "M667.5,135.9c0-43.3,21.3-82.5,55.6-110.8c8.6-7.1,18-13.5,28.1-19.1 c5.1-2.8,10.3-5.4,15.7-7.9V0h54.4v157H669.7v2.8c-0.5-2.6-0.9-5.2-1.2-7.8C667.9,146.7,667.5,141.3,667.5,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#8A2783"
    },
    d: "M669.4,135.9c0-42.9,21.1-81.7,55.1-109.8c8.5-7,17.8-13.4,27.8-19 c5-2.8,10.2-5.4,15.5-7.8V0h53.5v157H671.6v2.6c-0.5-2.6-0.9-5.2-1.2-7.8C669.7,146.6,669.4,141.3,669.4,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#8B2883"
    },
    d: "M671.3,135.9c0-42.4,20.8-80.9,54.6-108.7C742.7,13.3,762.7,2.1,785-5.7 V0h36.3v157h-148v2.3c-0.5-2.5-0.9-5.1-1.2-7.7C671.6,146.5,671.3,141.2,671.3,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#8C2983"
    },
    d: "M673.1,135.9c0-42,20.6-80,54-107.6c16.7-13.8,36.6-24.9,58.6-32.6V0 h35.6v157H675.3v2.1c-0.5-2.5-0.9-5.1-1.2-7.6C673.5,146.4,673.1,141.2,673.1,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#8D2A83"
    },
    d: "M675,135.9c0-41.6,20.4-79.2,53.5-106.5c16.5-13.6,36.2-24.7,58-32.3V0 h34.9v157H677.1v1.9c-0.5-2.5-0.8-5-1.2-7.5C675.3,146.3,675,141.1,675,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#8E2A84"
    },
    d: "M676.9,135.9c0-41.2,20.2-78.4,52.9-105.4C746.1,17,765.6,6.1,787.2-1.4 V0h34.2v157H678.9v1.6c-0.5-2.5-0.8-5-1.1-7.5C677.2,146.1,676.9,141.1,676.9,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#8F2B84"
    },
    d: "M678.7,135.9c0-40.7,20-77.6,52.4-104.3C747.3,18.3,766.5,7.4,787.9,0v0 h33.4v157H680.8v1.4c-0.5-2.4-0.8-4.9-1.1-7.4C679,146,678.7,141,678.7,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#8F2C84"
    },
    d: "M680.6,135.9c0-40.3,19.8-76.8,51.8-103.2c16-13.2,35.1-23.9,56.2-31.3 c5.3-1.8,10.7-3.5,16.3-4.9V0h16.5v157H682.6v1.2c-0.4-2.4-0.8-4.9-1.1-7.3C680.9,145.9,680.6,141,680.6,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#902D84"
    },
    d: "M682.4,135.9c0-39.9,19.6-76,51.3-102.1c15.8-13.1,34.7-23.6,55.7-31 c10.5-3.7,21.5-6.5,32.9-8.4L821.4,0v157H684.5v0.9c-0.4-2.4-0.8-4.8-1.1-7.2C682.8,145.8,682.4,140.9,682.4,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#912E84"
    },
    d: "M684.3,135.9c0-39.5,19.4-75.2,50.7-101.1 c15.7-12.9,34.3-23.4,55.1-30.6c10.4-3.6,21.2-6.4,32.5-8.3L821.4,0v157H686.3v0.7c-0.4-2.4-0.8-4.8-1.1-7.2 C684.6,145.7,684.3,140.9,684.3,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#922F84"
    },
    d: "M686.2,135.9c0-39,19.2-74.4,50.2-100c15.5-12.8,34-23.1,54.5-30.3 c10.3-3.6,21-6.4,32.2-8.2L821.4,0v157H688.1v0.5c-0.4-2.3-0.8-4.7-1.1-7.1C686.5,145.6,686.2,140.8,686.2,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#932F84"
    },
    d: "M688,135.9c0-38.6,19-73.6,49.6-98.9c15.3-12.7,33.6-22.9,53.9-30 c10.1-3.5,20.8-6.3,31.8-8.1l-2,1.1v157H690v0.2c-0.4-2.3-0.8-4.6-1.1-7C688.3,145.5,688,140.7,688,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#943085"
    },
    d: "M689.9,135.9c0-38.2,18.8-72.8,49.1-97.8c15.2-12.5,33.2-22.6,53.3-29.6 c10-3.5,20.6-6.2,31.5-8.1h-2.4V157H693.3v6.8C691.1,154.8,689.9,145.5,689.9,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#953185"
    },
    d: "M691.8,135.9c0-37.8,18.6-72,48.6-96.7c15-12.4,32.9-22.4,52.7-29.3 c9.9-3.5,20.3-6.1,31.1-8h-2.7V157H695.1v6.5C692.9,154.6,691.8,145.4,691.8,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#963285"
    },
    d: "M693.6,135.9c0-37.3,18.3-71.2,48-95.6c14.8-12.2,32.5-22.1,52.1-29 c9.8-3.4,20.1-6.1,30.8-7.9h-3.1V157H697v6.2C694.8,154.4,693.6,145.3,693.6,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#973385"
    },
    d: "M695.5,135.9c0-36.9,18.1-70.3,47.5-94.5c14.7-12.1,32.1-21.9,51.5-28.7 c9.7-3.4,19.9-6,30.4-7.8h-3.5v152H698.8v5.9C696.6,154.2,695.5,145.1,695.5,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#983485"
    },
    d: "M697.3,135.9c0-36.5,17.9-69.5,46.9-93.5c14.5-12,31.8-21.6,50.9-28.3 c9.6-3.3,19.6-5.9,30.1-7.7h-3.9V157H700.6v5.6C698.5,154,697.3,145,697.3,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#993585"
    },
    d: "M699.2,135.9c0-36.1,17.7-68.7,46.4-92.4c14.3-11.8,31.4-21.4,50.3-28 c9.5-3.3,19.4-5.9,29.7-7.6h-4.2v149h-119v5.3C700.3,153.7,699.2,144.9,699.2,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#9A3585"
    },
    d: "M701.1,135.9c0-35.6,17.5-67.9,45.8-91.3c14.2-11.7,31-21.1,49.7-27.7 c9.4-3.3,19.2-5.8,29.4-7.5h-4.6V157H704.3v5C702.2,153.5,701.1,144.8,701.1,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#9B3685"
    },
    d: "M702.9,135.9c0-35.2,17.3-67.1,45.3-90.2c14-11.5,30.6-20.9,49.1-27.3 c9.2-3.2,19-5.7,29-7.4h-5v146H706.1v4.6C704,153.3,702.9,144.7,702.9,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#9C3786"
    },
    d: "M704.8,135.9c0-34.8,17.1-66.3,44.7-89.1c13.8-11.4,30.3-20.6,48.5-27 c9.1-3.2,18.7-5.7,28.7-7.3h-5.4V157H707.9v4.3C705.9,153.1,704.8,144.6,704.8,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#9D3886"
    },
    d: "M706.7,135.9c0-34.4,16.9-65.5,44.2-88c13.7-11.3,29.9-20.4,48-26.7 c9-3.1,18.5-5.6,28.3-7.3h-5.8v143H709.7v4C707.7,152.9,706.7,144.5,706.7,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#9E3986"
    },
    d: "M708.5,135.9c0-33.9,16.7-64.7,43.6-86.9c13.5-11.1,29.5-20.1,47.4-26.3 c8.9-3.1,18.3-5.5,28-7.2h-6.1V157H711.6v3.7C709.6,152.7,708.5,144.4,708.5,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#9F3A86"
    },
    d: "M710.4,135.9c0-33.5,16.5-63.9,43.1-85.8c13.3-11,29.2-19.9,46.8-26 c8.8-3.1,18-5.5,27.6-7.1h-6.5v140h-108v3.4C711.4,152.5,710.4,144.3,710.4,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#A03B86"
    },
    d: "M712.2,135.9c0-33.1,16.3-63.1,42.6-84.8c13.1-10.8,28.8-19.6,46.2-25.7 c8.7-3,17.8-5.4,27.3-7h-6.9V157H715.2v3.1C713.3,152.3,712.2,144.2,712.2,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#A13C86"
    },
    d: "M714.1,135.9c0-32.7,16.1-62.3,42-83.7c13-10.7,28.4-19.4,45.6-25.4 c4.3-1.5,8.7-2.8,13.2-4c2.2-0.6,4.5-1.1,6.8-1.6h-0.3V157H717v2.8C715.1,152.1,714.1,144.1,714.1,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#A23D87"
    },
    d: "M716,135.9c0-32.3,15.8-61.5,41.5-82.6c12.8-10.6,28.1-19.1,45-25 c4.2-1.5,8.6-2.8,13-3.9c2.2-0.6,4.5-1.1,6.7-1.6h-0.8V157H718.8v2.5C717,151.9,716,144,716,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#A33E87"
    },
    d: "M717.8,135.9c0-31.8,15.6-60.6,40.9-81.5c12.6-10.4,27.7-18.9,44.4-24.7 c4.2-1.5,8.5-2.8,12.8-3.9c2.2-0.6,4.4-1.1,6.6-1.6h-1.2V157H720.7v2.2C718.8,151.6,717.8,143.9,717.8,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#A43F87"
    },
    d: "M719.7,135.9c0-31.4,15.4-59.8,40.4-80.4c12.5-10.3,27.3-18.6,43.8-24.4 c4.1-1.4,8.3-2.7,12.7-3.8c2.2-0.6,4.3-1.1,6.5-1.5h-1.7V157h-98.9v1.9C720.7,151.4,719.7,143.8,719.7,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#A54087"
    },
    d: "M721.6,135.9c0-31,15.2-59,39.8-79.3c12.3-10.2,27-18.4,43.2-24 c4.1-1.4,8.2-2.7,12.5-3.8c2.1-0.5,4.3-1.1,6.5-1.5h-2.2V157h-97.1v1.5C722.5,151.2,721.6,143.7,721.6,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#A64087"
    },
    d: "M723.4,135.9c0-30.6,15-58.2,39.3-78.2c12.1-10,26.6-18.1,42.6-23.7 c4-1.4,8.1-2.6,12.3-3.7c2.1-0.5,4.2-1,6.4-1.5h-2.6V157h-95.2v1.2C724.4,151,723.4,143.6,723.4,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#A74187"
    },
    d: "M725.3,135.9c0-30.1,14.8-57.4,38.7-77.2c12-9.9,26.2-17.9,42-23.4 c4-1.4,8-2.6,12.2-3.7c2.1-0.5,4.2-1,6.3-1.5h-3.1V157H728v0.9C726.2,150.8,725.3,143.5,725.3,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#A84287"
    },
    d: "M727.1,135.9c0-29.7,14.6-56.6,38.2-76.1c11.8-9.7,25.8-17.6,41.4-23.1 c3.9-1.4,7.9-2.6,12-3.6c2-0.5,4.1-1,6.2-1.4h-3.6V157h-91.6v0.6C728.1,150.6,727.1,143.3,727.1,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#A94388"
    },
    d: "M729,135.9c0-29.3,14.4-55.8,37.6-75c11.6-9.6,25.5-17.4,40.9-22.7 c3.8-1.3,7.8-2.5,11.8-3.6c2-0.5,4-1,6.1-1.4h-4V157h-89.8v0.3C729.9,150.4,729,143.2,729,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#AA4488"
    },
    d: "M730.9,135.9c0-28.9,14.2-55,37.1-73.9c11.5-9.5,25.1-17.1,40.3-22.4 c3.8-1.3,7.7-2.5,11.6-3.5c2-0.5,4-1,6-1.4h-4.5V157h-86.5v5.1c-0.5-1.7-1-3.4-1.4-5.1C731.8,150.2,730.9,143.1,730.9,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#AB4588"
    },
    d: "M732.7,135.9c0-28.4,14-54.2,36.6-72.8C780.6,53.8,794,46.3,809,41 c3.7-1.3,7.6-2.5,11.5-3.5c2-0.5,3.9-1,5.9-1.4h-5V157h-84.7v4.7c-0.5-1.6-1-3.3-1.4-5C733.6,150,732.7,143,732.7,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#AC4688"
    },
    d: "M734.6,135.9c0-28,13.8-53.4,36-71.7c11.1-9.2,24.4-16.6,39.1-21.7 c3.7-1.3,7.4-2.4,11.3-3.4c1.9-0.5,3.9-0.9,5.8-1.4h-5.4V157h-82.9v4.3c-0.5-1.6-1-3.3-1.4-4.9 C735.5,149.8,734.6,142.9,734.6,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#AD4788"
    },
    d: "M736.5,135.9c0-27.6,13.6-52.6,35.5-70.6c11-9,24-16.4,38.5-21.4 c3.6-1.3,7.3-2.4,11.1-3.4h-0.2V157h-81.1v3.9c-0.5-1.6-0.9-3.2-1.4-4.8C737.3,149.5,736.5,142.8,736.5,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#AE4888"
    },
    d: "M738.3,135.9c0-27.2,13.3-51.7,34.9-69.5c10.8-8.9,23.6-16.1,37.9-21.1 c3.6-1.2,7.2-2.3,11-3.3h-0.7v115h-79.3v3.5c-0.5-1.6-0.9-3.2-1.3-4.8C739.2,149.3,738.3,142.7,738.3,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#AF4988"
    },
    d: "M740.2,135.9c0-26.7,13.1-50.9,34.4-68.5c10.6-8.8,23.3-15.8,37.3-20.7 c3.5-1.2,7.1-2.3,10.8-3.3h-1.3V157h-77.5v3.1c-0.5-1.5-0.9-3.1-1.3-4.7C741,149.1,740.2,142.6,740.2,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#B04A89"
    },
    d: "M742.1,135.9c0-26.3,12.9-50.1,33.8-67.4c10.4-8.6,22.9-15.6,36.7-20.4 c3.5-1.2,7-2.3,10.6-3.2h-1.8V157h-75.7v2.7c-0.5-1.5-0.9-3.1-1.3-4.6C742.9,148.9,742.1,142.5,742.1,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#B24B89"
    },
    d: "M743.9,135.9c0-25.9,12.7-49.3,33.3-66.3c10.3-8.5,22.5-15.3,36.1-20.1 c3.4-1.2,6.9-2.2,10.4-3.2h-2.4V157H749v6.8c-1.1-2.9-2-5.9-2.8-9C744.7,148.7,743.9,142.4,743.9,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#B34C89"
    },
    d: "M745.8,135.9c0-25.5,12.5-48.5,32.7-65.2c10.1-8.3,22.2-15.1,35.5-19.8 c3.3-1.2,6.8-2.2,10.3-3.1h-2.9V157h-70.6v6.4c-1.1-2.9-2-5.8-2.8-8.8C746.6,148.5,745.8,142.3,745.8,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#B44D89"
    },
    d: "M747.6,135.9c0-25,12.3-47.7,32.2-64.1c9.9-8.2,21.8-14.8,34.9-19.4 c3.3-1.1,6.7-2.2,10.1-3h-3.5V157h-68.8v5.9c-1.1-2.8-2-5.7-2.7-8.7C748.4,148.3,747.6,142.2,747.6,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#B54E89"
    },
    d: "M749.5,135.9c0-24.6,12.1-46.9,31.6-63c9.8-8.1,21.4-14.6,34.3-19.1 c3.2-1.1,6.5-2.1,9.9-3h-4V157h-67v5.4c-1.1-2.8-1.9-5.6-2.7-8.5C750.3,148.1,749.5,142.1,749.5,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#B64F89"
    },
    d: "M751.4,135.9c0-24.2,11.9-46.1,31.1-61.9c9.6-7.9,21-14.3,33.7-18.8 c3.2-1.1,6.4-2.1,9.8-2.9h-4.6V157h-65.2v5c-1-2.7-1.9-5.5-2.6-8.4C752.1,147.9,751.4,142,751.4,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#B7508A"
    },
    d: "M753.2,135.9c0-23.8,11.7-45.3,30.6-60.9c9.4-7.8,20.7-14.1,33.2-18.4 c3.1-1.1,6.3-2.1,9.6-2.9h-5.1V157h-63.5v4.5c-1-2.7-1.9-5.4-2.6-8.2C754,147.7,753.2,141.9,753.2,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#B8518A"
    },
    d: "M755.1,135.9c0-23.3,11.5-44.5,30-59.8c9.3-7.6,20.3-13.8,32.6-18.1 c3.1-1.1,6.2-2,9.4-2.8h-5.7V157h-61.7v4.1c-1-2.6-1.8-5.3-2.5-8.1C755.8,147.5,755.1,141.8,755.1,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#B9528A"
    },
    d: "M757,135.9c0-22.9,11.3-43.7,29.5-58.7c9.1-7.5,19.9-13.6,32-17.8 c3-1,6.1-2,9.2-2.8h-6.2V157h-59.9v3.6c-1-2.6-1.8-5.3-2.5-8C757.7,147.2,757,141.6,757,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#BA538A"
    },
    d: "M758.8,135.9c0-22.5,11-42.9,28.9-57.6c8.9-7.4,19.6-13.3,31.4-17.5 c3-1,6-1.9,9.1-2.7h-6.8V157h-58.1v3.2c-1-2.6-1.8-5.2-2.4-7.8C759.5,147,758.8,141.5,758.8,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#BB548A"
    },
    d: "M760.7,135.9c0-22.1,10.8-42,28.4-56.5c8.8-7.2,19.2-13.1,30.8-17.1 c1.4-0.5,2.9-1,4.4-1.4h-2.9V157H765v2.7c-0.9-2.5-1.7-5.1-2.4-7.7C761.4,146.8,760.7,141.4,760.7,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#BD558A"
    },
    d: "M762.5,135.9c0-21.6,10.6-41.2,27.8-55.4c8.6-7.1,18.8-12.8,30.2-16.8 c1.4-0.5,2.9-1,4.3-1.4h-3.5V157h-54.6v2.2c-0.9-2.5-1.7-5-2.3-7.5C763.2,146.6,762.5,141.3,762.5,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#BE568B"
    },
    d: "M764.4,135.9c0-21.2,10.4-40.4,27.3-54.3c8.4-7,18.5-12.6,29.6-16.5 c1.4-0.5,2.8-0.9,4.2-1.4h-4.1V157h-52.8v1.8c-0.9-2.4-1.7-4.9-2.3-7.4C765.1,146.4,764.4,141.2,764.4,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#BF578B"
    },
    d: "M766.3,135.9c0-20.8,10.2-39.6,26.7-53.2c8.3-6.8,18.1-12.3,29-16.1 h-0.6V157h-51v1.3c-0.9-2.4-1.6-4.8-2.2-7.2C766.9,146.2,766.3,141.1,766.3,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#C0588B"
    },
    d: "M768.1,135.9c0-20.4,10-38.8,26.2-52.2c8.1-6.7,17.7-12.1,28.4-15.8 h-1.4v89h-49.2v0.9c-0.9-2.3-1.6-4.7-2.2-7.1C768.8,146,768.1,141,768.1,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#C1598B"
    },
    d: "M770,135.9c0-19.9,9.8-38,25.6-51.1c7.9-6.5,17.4-11.8,27.8-15.5h-2.1 V157h-47.5v0.4c-0.9-2.3-1.6-4.6-2.2-6.9C770.6,145.8,770,140.9,770,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#C25A8B"
    },
    d: "M771.9,135.9c0-19.5,9.6-37.2,25.1-50c7.8-6.4,17-11.6,27.2-15.1h-2.8 V157h-42.8v6.5C774.3,155,771.9,145.7,771.9,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#C35B8B"
    },
    d: "M773.7,135.9c0-19.1,9.4-36.4,24.6-48.9c7.6-6.3,16.6-11.3,26.6-14.8 h-3.5V157h-41.1v5.9C776.1,154.6,773.7,145.5,773.7,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#C45C8C"
    },
    d: "M775.6,135.9c0-18.7,9.2-35.6,24-47.8C807,82,815.8,77,825.6,73.6h-4.3 V157H782v5.3C777.9,154.1,775.6,145.3,775.6,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#C65D8C"
    },
    d: "M777.4,135.9c0-18.2,9-34.8,23.5-46.7c7.2-6,15.9-10.8,25.5-14.2h-5v82 h-37.6v4.7C779.7,153.7,777.4,145,777.4,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#C75E8C"
    },
    d: "M779.3,135.9c0-17.8,8.8-34,22.9-45.6c7.1-5.8,15.5-10.6,24.9-13.8h-5.7 V157h-35.9v4.1C781.5,153.3,779.3,144.8,779.3,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#C85F8C"
    },
    d: "M781.2,135.9c0-17.4,8.5-33.2,22.4-44.6c6.9-5.7,15.1-10.3,24.3-13.5 h-6.4V157h-34.2v3.5C783.3,152.9,781.2,144.6,781.2,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#C9608C"
    },
    d: "M783,135.9c0-17,8.3-32.3,21.8-43.5c3.4-2.8,7.1-5.3,11-7.5 c2-1.1,4-2.1,6.1-3.1h-0.6V157h-32.5v2.9C785.1,152.5,783,144.4,783,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#CA618C"
    },
    d: "M784.9,135.9c0-16.6,8.1-31.5,21.3-42.4c3.3-2.7,6.9-5.2,10.8-7.3 c1.9-1.1,3.9-2.1,6-3h-1.5V157h-30.8v2.3C786.9,152.1,784.9,144.2,784.9,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#CB628D"
    },
    d: "M786.8,135.9c0-16.1,7.9-30.7,20.7-41.3c3.2-2.6,6.7-5,10.5-7.1 c1.9-1,3.8-2,5.8-2.9h-2.4V157h-29.1v1.7C788.7,151.7,786.8,144,786.8,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#CC638D"
    },
    d: "M788.6,135.9c0-15.7,7.7-29.9,20.2-40.2c3.1-2.6,6.5-4.9,10.2-6.9 c1.8-1,3.7-2,5.7-2.8h-3.3V157H794v1.1C790.5,151.2,788.6,143.8,788.6,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#CE648D"
    },
    d: "M790.5,135.9c0-15.3,7.5-29.1,19.6-39.1c3-2.5,6.4-4.8,9.9-6.8 c1.8-1,3.6-1.9,5.5-2.8h-4.2V157h-25.6v0.5C792.4,150.8,790.5,143.6,790.5,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#CF668D"
    },
    d: "M792.3,135.9c0-14.9,7.3-28.3,19.1-38c2.9-2.4,6.2-4.6,9.6-6.6 c1.7-1,3.5-1.9,5.4-2.7h-5.1V157h-21.2v4.6c-1-1.5-1.9-3.1-2.7-4.7C794.2,150.4,792.3,143.3,792.3,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#D0678D"
    },
    d: "M794.2,135.9c0-14.4,7.1-27.5,18.5-36.9c2.9-2.4,6-4.5,9.4-6.4h-0.7V157 h-19.5v3.8c-1-1.5-1.9-3-2.7-4.6C796,150,794.2,143.1,794.2,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#D1688D"
    },
    d: "M796.1,135.9c0-14,6.9-26.7,18-35.9c2.8-2.3,5.8-4.4,9.1-6.2h-1.8V157 h-17.9v3.1c-0.9-1.4-1.8-2.9-2.6-4.4C797.8,149.6,796.1,142.9,796.1,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#D2698E"
    },
    d: "M797.9,135.9c0-13.6,6.7-25.9,17.5-34.8c2.7-2.2,5.7-4.2,8.8-6h-2.8V157 h-13.3v6.4c-2.1-2.6-4-5.4-5.5-8.4C799.6,149.2,797.9,142.7,797.9,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#D36A8E"
    },
    d: "M799.8,135.9c0-13.2,6.5-25.1,16.9-33.7c2.6-2.2,5.5-4.1,8.5-5.8h-3.9 V157h-11.7v5.6c-2.1-2.5-3.9-5.2-5.3-8.1C801.4,148.8,799.8,142.5,799.8,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#D56B8E"
    },
    d: "M801.7,135.9c0-12.7,6.3-24.3,16.4-32.6c2.5-2.1,5.3-4,8.3-5.6h-4.9V157 h-10.2v4.7c-2-2.5-3.7-5.1-5.2-7.8C803.2,148.3,801.7,142.3,801.7,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#D66C8E"
    },
    d: "M803.5,135.9c0-12.3,6-23.4,15.8-31.5c2.4-2,5.1-3.8,8-5.4h-6v58h-8.6 v3.9c-1.9-2.4-3.6-4.9-5-7.6C805,147.9,803.5,142.1,803.5,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#D76D8E"
    },
    d: "M805.4,135.9c0-11.9,5.8-22.6,15.3-30.4c2.4-1.9,4.9-3.7,7.7-5.3h-7V157 h-7.1v3c-1.9-2.3-3.5-4.7-4.8-7.3C806.8,147.5,805.4,141.9,805.4,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#D86E8E"
    },
    d: "M807.2,135.9c0-11.5,5.6-21.8,14.7-29.3h-0.6V157h-5.5v2.1 c-1.8-2.2-3.4-4.6-4.6-7C808.7,147.1,807.2,141.6,807.2,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#D96F8F"
    },
    d: "M809.1,135.9c0-11,5.4-21,14.2-28.3h-1.9V157h-4v1.3 c-1.7-2.1-3.2-4.4-4.5-6.8C810.5,146.7,809.1,141.4,809.1,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#DB708F"
    },
    d: "M811,135.9c0-10.6,5.2-20.2,13.6-27.2h-3.2V157l3.2,6.1 C816.2,156.1,811,146.5,811,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#DC718F"
    },
    d: "M812.8,135.9c0-10.2,5-19.4,13.1-26.1h-4.5V157l4.5,5 C817.8,155.3,812.8,146.1,812.8,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#DD728F"
    },
    d: "M814.7,135.9c0-9.8,4.8-18.6,12.5-25h-5.9V157l5.9,3.9 C819.5,154.5,814.7,145.7,814.7,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#DE748F"
    },
    d: "M816.6,135.9c0-4.7,1.1-9.1,3.2-13.2c1-2,2.3-3.9,3.8-5.7h-2.2v37.8h2.2 c-1.5-1.8-2.7-3.7-3.8-5.7C817.7,145,816.6,140.6,816.6,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#DF758F"
    },
    d: "M818.4,135.9c0-4.5,1.1-8.7,3.1-12.6h-0.1v25.1h0.1 C819.5,144.6,818.4,140.4,818.4,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#E17690"
    },
    d: "M820.3,135.9c0-4.2,1-8.3,2.9-12h-1.8v23.9h1.8 C821.3,144.2,820.3,140.2,820.3,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#E27790"
    },
    d: "M821.4,135.9v-29.2V135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#E37890"
    },
    d: "M821.4,135.9v-27.7V135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#E47990"
    },
    d: "M821.4,135.9v-26.1V135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#E57A90"
    },
    d: "M821.4,135.9v-24.6V135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#E77B90"
    },
    d: "M821.4,135.9v-23.1V135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#E87C91"
    },
    d: "M821.4,135.9v-21.5V135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#E97D91"
    },
    d: "M821.4,135.9v-20V135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#EA7F91"
    },
    d: "M821.4,135.9v-18.4V135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#EC8091"
    },
    d: "M821.4,135.9V119V135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#ED8191"
    },
    d: "M821.4,135.9v-15.4V135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#EE8292"
    },
    d: "M821.4,135.9v-13.8V135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#EF8392"
    },
    d: "M821.4,135.9v-12.3V135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#F18492"
    },
    d: "M821.4,135.9v-10.8V135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#F28592"
    },
    d: "M821.4,135.9v-9.2V135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#F38692"
    },
    d: "M821.4,135.9v-7.7V135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#F48892"
    },
    d: "M821.4,135.9v-6.1V135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#F58993"
    },
    d: "M821.4,135.9v-4.6V135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#F78A93"
    },
    d: "M821.4,135.9v-3.1V135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SentSVGID_2_)",
      fill: "#F88B93"
    },
    d: "M821.4,135.9v-1.5V135.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SentSVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 396.0513,
    y1: 253.2114,
    x2: 158.4492,
    y2: 221.9052,
    gradientTransform: "matrix(0.587 0.5044 -1.1918 0.5778 783.6099 -283.2282)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCBA9D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5634,
    style: {
      stopColor: "#EE8594"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4608D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SentSVGID_3_)"
    },
    points: "820.4,1 624.1,96.2 559.6,58.9  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SentSVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 1272.267,
    y1: 124.5042,
    x2: 1402.347,
    y2: 105.5458,
    gradientTransform: "matrix(-0.8737 -0.3389 -1.0008 0.6881 2028.7284 436.1181)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCBA9D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5634,
    style: {
      stopColor: "#EE8594"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4608D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SentSVGID_4_)"
    },
    points: "820.4,1 655.5,114.3 720,151.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SentSVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 602.5536,
    y1: 177.5821,
    x2: 420.9058,
    y2: 101.991,
    gradientTransform: "matrix(0.866 0.5 -0.866 0.5 410.4385 -243.8226)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F88B93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2064,
    style: {
      stopColor: "#D76D8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5733,
    style: {
      stopColor: "#A23D87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8491,
    style: {
      stopColor: "#811F82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#751480"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SentSVGID_5_)"
    },
    points: "655.5,114.3 820.4,1 624.1,96.2 639.8,156  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FCC29F"
    },
    points: "621.2,94.5 820.4,1 624.1,96.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FBA999"
    },
    points: "655.5,114.3 820.4,1 658.1,115.8  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4,
      fill: "#0B0244"
    },
    points: "778.6,160.3 601.3,199.7 643.2,223.9 643.2,223.9 645.2,225 668.6,223.3  679.9,245 710.4,262.7 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6966AE"
    },
    d: "M2.3 151.7C54 140 112 140 162.9 155.4c21.5 6.5 43.2 16.9 58.4 33.9 5-.5 10-.6 14.9-.5 22.6.4 45.3 5.7 66.1 14.3 11.5 4.8 22.2 11.4 33.2 17.2 14.4 7.6 29 14.7 44.2 20.7 28.6 11.2 62.5 19.6 91.9 6.5 5.7-2.5 11.3-5.9 16.2-10.1-25.5-10.1-47.9-30.8-51.5-58.9-3.3-25.7 20-47.4 45.4-44.7 19.7 2.2 29.4 22 32.5 39.5 3.4 19.2 1.3 42.3-10.4 58.5-.7.9-1.4 1.9-2.1 2.7 1.6.5 3.3.9 4.9 1.3 26 6 56 1.3 79.4-11.4 23.9-12.9 40.2-35.6 48.3-61.1.8-2.6 4.9-1.6 4.1 1.1-8.4 28.4-26.1 52.5-52.4 66.8-26.5 14.4-60.2 17.7-89 9.4-.2-.1-.4-.1-.6-.2-17.6 17.1-43.7 23.2-67.8 21.3-31.3-2.5-61.1-15.9-88.8-30-22-11.2-42.3-23.5-66.4-29.6-14.8-3.7-30.6-6-46.1-5.2 13.1 18.6 18.1 43.3 8.9 64.7-10.8 25.2-44.1 26.2-63.7 10.9-19.8-15.6-11.1-48.5 3.8-64.3 9.4-10 22.3-15.1 35.8-17.5-.6-.6-1.2-1.2-1.8-1.7-17-15.8-40-24.1-62.1-29.5-46.1-11.1-97.5-10.6-143.7-.1-4.9.8-7.1-6.6-2.2-7.7zm498.8 69.7c4.8-9.2 6.6-20.1 6.9-30.4.6-17.5-4.1-44-24-49.4-9.5-2.6-20.4 1.6-28.3 6.8-11.2 7.4-13.8 21.5-11.4 33.9 4.8 24.5 26.6 41.1 49.3 49.5 3-3.2 5.5-6.6 7.5-10.4zm-297.5-20.6c-22.3 6.9-40.2 30.7-33.3 54.8 4.3 15.2 23.9 20.4 37.8 18.9 13.6-1.4 21.4-13.2 24.2-25.4 4.2-18.4-2.3-37-13.8-51.5-5.1.6-10 1.7-14.9 3.2z"
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sent.4dcbb847.svg";
export { ForwardRef as ReactComponent };